import { useEffect, useState } from "react";
import { ArrowRight, ChevronLeft, ChevronRight, HardHat, X } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";
import { isPreOpening } from "../../lib/openingDate";

const categories = [
  {
    "key": "fachada",
    "title": { "pt": "Fachada", "en": "Façade", "fr": "Façade", "es": "Fachada", "de": "Fassade" },
    "photos": [
      { "src": "/assets/casa/frente.jpg", "alt": { pt: "Fachada da casa", en: "House façade", fr: "Façade de la maison", es: "Fachada de la casa", de: "Fassade des Hauses" } }
    ]
  },
  {
    "key": "jacuzzi",
    "title": {
      "pt": "Jacuzzi e pátio privado",
      "en": "Jacuzzi and private patio",
      "fr": "Jacuzzi et patio privé",
      "es": "Jacuzzi y patio privado",
      "de": "Whirlpool und privater Patio"
    },
    "photos": [
      { "src": "/assets/casa/jacuzzi/01-01-jacuzzi-visao-geral-patio.webp", "alt": { pt: "Jacuzzi & pátio privado", en: "Jacuzzi & private patio", fr: "Jacuzzi & patio privé", es: "Jacuzzi & patio privado", de: "Whirlpool & privater Patio" } },
      { "src": "/assets/casa/jacuzzi/02-03-jacuzzi-vertical-patio-escadas.webp", "alt": { pt: "Pátio coberto", en: "Covered patio", fr: "Patio couvert", es: "Patio cubierto", de: "Überdachter Patio" } },
      { "src": "/assets/casa/jacuzzi/03-04-jacuzzi-agua-borbulhas-close.webp", "alt": { pt: "Borbulhas relaxantes", en: "Relaxing bubbles", fr: "Bulles relaxantes", es: "Burbujas relajantes", de: "Entspannende Blasen" } },
      { "src": "/assets/casa/jacuzzi/04-06-jacuzzi-escadas-luzes.webp", "alt": { pt: "Luzes ao entardecer", en: "Lights at dusk", fr: "Lumières au crépuscule", es: "Luces al atardecer", de: "Lichter in der Dämmerung" } },
      { "src": "/assets/casa/jacuzzi/05-08-jacuzzi-escadas-e-jacuzzi.webp", "alt": { pt: "Escadas de acesso", en: "Access staircase", fr: "Escalier d'accès", es: "Escalera de acceso", de: "Zugangstreppe" } },
      { "src": "/assets/casa/jacuzzi/06-11-jacuzzi-com-pessoa-b.webp", "alt": { pt: "Momento de relaxamento", en: "A moment to relax", fr: "Instant de détente", es: "Momento de relax", de: "Moment der Entspannung" } },
      { "src": "/assets/casa/jacuzzi/07-12-jacuzzi-com-pessoa-c.webp", "alt": { pt: "Águas quentes ao fim do dia", en: "Warm waters at day's end", fr: "Eaux chaudes en fin de journée", es: "Aguas cálidas al final del día", de: "Warmes Wasser am Tagesende" } },
      { "src": "/assets/casa/jacuzzi/08-13-jacuzzi-com-pessoa-d.webp", "alt": { pt: "Sorrisos no jacuzzi", en: "Smiles in the jacuzzi", fr: "Sourires dans le jacuzzi", es: "Sonrisas en el jacuzzi", de: "Lächeln im Whirlpool" } }
    ]
  },
  {
    "key": "sala",
    "title": { "pt": "Sala", "en": "Living room", "fr": "Salon", "es": "Sala de estar", "de": "Wohnzimmer" },
    "photos": [
      { "src": "/assets/casa/sala/01-01-detalhe-globo-prateleira-b.webp", "alt": { pt: "Globo de viagem", en: "Travel globe", fr: "Globe de voyage", es: "Globo terráqueo", de: "Reise-Globus" } },
      { "src": "/assets/casa/sala/02-01-sala-visao-geral-capa.webp", "alt": { pt: "Sala de estar · Vista geral", en: "Living room · Full view", fr: "Salon · Vue d'ensemble", es: "Sala de estar · Vista general", de: "Wohnzimmer · Gesamtansicht" } },
      { "src": "/assets/casa/sala/03-02-detalhe-guia-boas-vindas.webp", "alt": { pt: "Bem-vindos à vossa casa", en: "Welcome to your home", fr: "Bienvenue chez vous", es: "Bienvenidos a vuestra casa", de: "Willkommen in Ihrem Zuhause" } },
      { "src": "/assets/casa/sala/04-02-sala-parede-decorativa.webp", "alt": { pt: "Detalhes com alma", en: "Details with soul", fr: "Détails pleins d'âme", es: "Detalles con alma", de: "Details mit Seele" } },
      { "src": "/assets/casa/sala/05-03-detalhe-parede-decorativa-b.webp", "alt": { pt: "Luz de ambiente", en: "Ambient light", fr: "Lumière d'ambiance", es: "Luz de ambiente", de: "Stimmungslicht" } },
      { "src": "/assets/casa/sala/06-04-detalhe-arranjo-mesa.webp", "alt": { pt: "Candeeiro & velas", en: "Lamp & candles", fr: "Lampe & bougies", es: "Lámpara & velas", de: "Lampe & Kerzen" } },
      { "src": "/assets/casa/sala/07-04-sala-sofa-teto-madeira.webp", "alt": { pt: "Sala & cozinha", en: "Living room & kitchen", fr: "Salon & cuisine", es: "Sala & cocina", de: "Wohnzimmer & Küche" } },
      { "src": "/assets/casa/sala/08-05-detalhe-time-to-travel.webp", "alt": { pt: "Tempo de viajar", en: "Time to travel", fr: "L'heure de voyager", es: "Hora de viajar", de: "Zeit zu reisen" } },
      { "src": "/assets/casa/sala/09-06-sala-vertical-sofa-cozinha.webp", "alt": { pt: "Sofá & vista para a cozinha", en: "Sofa & kitchen view", fr: "Canapé & vue sur la cuisine", es: "Sofá & vista a la cocina", de: "Sofa & Blick zur Küche" } },
      { "src": "/assets/casa/sala/10-07-noite-luz-ambiente-a.webp", "alt": { pt: "Ambiente noturno", en: "Evening ambience", fr: "Ambiance nocturne", es: "Ambiente nocturno", de: "Abendstimmung" } },
      { "src": "/assets/casa/sala/11-09-noite-prateleiras-quarto.webp", "alt": { pt: "Cantos com charme", en: "Charming corners", fr: "Coins pleins de charme", es: "Rincones con encanto", de: "Charmante Ecken" } },
      { "src": "/assets/casa/sala/12-10-detalhe-welcome-home-b.webp", "alt": { pt: "Welcome Home", en: "Welcome Home", fr: "Welcome Home", es: "Welcome Home", de: "Welcome Home" } },
      { "src": "/assets/casa/sala/13-223031.webp", "alt": { pt: "Sala ao serão", en: "Living room by night", fr: "Salon en soirée", es: "Sala al anochecer", de: "Wohnzimmer am Abend" } },
      { "src": "/assets/casa/sala/14-223045.webp", "alt": { pt: "Serão em família", en: "Family evenings", fr: "Soirées en famille", es: "Noches en familia", de: "Gemütliche Abende" } }
    ]
  },
  {
    "key": "cozinha",
    "title": { "pt": "Cozinha", "en": "Kitchen", "fr": "Cuisine", "es": "Cocina", "de": "Küche" },
    "photos": [
      { "src": "/assets/casa/cozinha/01-01-cozinha-frente-vertical-a.webp", "alt": { pt: "Armários & bancada", en: "Cabinets & counter", fr: "Placards & plan de travail", es: "Armarios & encimera", de: "Schränke & Arbeitsplatte" } },
      { "src": "/assets/casa/cozinha/02-06-cozinha-bancada-vertical-a.webp", "alt": { pt: "Bancada & luz natural", en: "Counter & natural light", fr: "Plan de travail & lumière naturelle", es: "Encimera & luz natural", de: "Arbeitsplatte & Tageslicht" } },
      { "src": "/assets/casa/cozinha/03-09-cozinha-visao-geral-janela-b.webp", "alt": { pt: "Janela com vista", en: "Window with a view", fr: "Fenêtre avec vue", es: "Ventana con vistas", de: "Fenster mit Aussicht" } },
      { "src": "/assets/casa/cozinha/04-11-cozinha-quadros-decorativos-b.webp", "alt": { pt: "Quadros decorativos", en: "Decorative art", fr: "Tableaux décoratifs", es: "Cuadros decorativos", de: "Dekorative Bilder" } },
      { "src": "/assets/casa/cozinha/05-13-cozinha-visao-geral-horizontal-b.webp", "alt": { pt: "Forno & micro-ondas", en: "Oven & microwave", fr: "Four & micro-ondes", es: "Horno & microondas", de: "Ofen & Mikrowelle" } },
      { "src": "/assets/casa/cozinha/06-14-cozinha-frase-decorativa.webp", "alt": { pt: "O segredo é sempre o amor", en: "The secret ingredient is love", fr: "Le secret, c'est toujours l'amour", es: "El secreto es siempre el amor", de: "Das Geheimnis ist immer Liebe" } },
      { "src": "/assets/casa/cozinha/07-16-cozinha-cha-cafe-vertical-a.webp", "alt": { pt: "Café & chá prontos", en: "Coffee & tea ready", fr: "Café & thé prêts", es: "Café & té listos", de: "Kaffee & Tee bereit" } },
      { "src": "/assets/casa/cozinha/08-18-cozinha-facas-airfryer-a.webp", "alt": { pt: "Air fryer & utensílios", en: "Air fryer & utensils", fr: "Air fryer & ustensiles", es: "Air fryer & utensilios", de: "Heißluftfritteuse & Utensilien" } },
      { "src": "/assets/casa/cozinha/09-20-cozinha-vinho-area-refeicoes.webp", "alt": { pt: "Para brindar", en: "Time to toast", fr: "Pour trinquer", es: "Para brindar", de: "Zum Anstoßen" } },
      { "src": "/assets/casa/cozinha/10-223135.webp", "alt": { pt: "Jantar em casa", en: "Dinner at home", fr: "Dîner à la maison", es: "Cena en casa", de: "Abendessen zu Hause" } },
      { "src": "/assets/casa/cozinha/11-223146.webp", "alt": { pt: "Cozinha ao serão", en: "Kitchen by night", fr: "Cuisine en soirée", es: "Cocina al anochecer", de: "Küche am Abend" } }
    ]
  },
  {
    "key": "quarto-principal",
    "title": { "pt": "Quarto principal", "en": "Main bedroom", "fr": "Chambre principale", "es": "Dormitorio principal", "de": "Hauptschlafzimmer" },
    "photos": [
      { "src": "/assets/casa/quarto-principal/01-02-quarto-duas-camas-entrada.webp", "alt": { pt: "Configuração 2 camas individuais", en: "Twin bed setup", fr: "Configuration 2 lits simples", es: "Configuración 2 camas individuales", de: "Zwei-Einzelbetten-Aufteilung" } },
      { "src": "/assets/casa/quarto-principal/02-03-quarto-duas-camas-janela.webp", "alt": { pt: "Luz da janela", en: "Window light", fr: "Lumière de la fenêtre", es: "Luz de la ventana", de: "Licht vom Fenster" } },
      { "src": "/assets/casa/quarto-principal/03-04-quarto-casal-entrada-teto.webp", "alt": { pt: "Camas juntas: espaço para casal", en: "Beds joined: space for a couple", fr: "Lits joints : espace pour un couple", es: "Camas juntas: espacio para pareja", de: "Zusammengestellte Betten: Platz für ein Paar" } },
      { "src": "/assets/casa/quarto-principal/04-07-quarto-casal-luzes-c.webp", "alt": { pt: "Luzes de leitura", en: "Reading lights", fr: "Lampes de lecture", es: "Luces de lectura", de: "Leselampen" } },
      { "src": "/assets/casa/quarto-principal/05-222958.webp", "alt": { pt: "Noite tranquila", en: "A quiet night", fr: "Une nuit tranquille", es: "Una noche tranquila", de: "Eine ruhige Nacht" } }
    ]
  },
  {
    "key": "quarto-secundario",
    "title": { "pt": "Quarto secundário", "en": "Second bedroom", "fr": "Deuxième chambre", "es": "Segundo dormitorio", "de": "Zweites Schlafzimmer" },
    "photos": [
      { "src": "/assets/casa/quarto-secundario/01-01-quarto-secundario-duas-camas-entrada-a.webp", "alt": { pt: "Duas camas individuais", en: "Two single beds", fr: "Deux lits simples", es: "Dos camas individuales", de: "Zwei Einzelbetten" } },
      { "src": "/assets/casa/quarto-secundario/02-02-quarto-secundario-duas-camas-entrada-b.webp", "alt": { pt: "Vista geral", en: "Full view", fr: "Vue d'ensemble", es: "Vista general", de: "Gesamtansicht" } },
      { "src": "/assets/casa/quarto-secundario/03-05-quarto-secundario-detalhe-live.webp", "alt": { pt: "Every moment · Live", en: "Every moment · Live", fr: "Every moment · Live", es: "Every moment · Live", de: "Every moment · Live" } },
      { "src": "/assets/casa/quarto-secundario/04-06-quarto-secundario-cama-junta-saida-c.webp", "alt": { pt: "Duas camas ou casal, à escolha", en: "Twin or double, your choice", fr: "Deux lits ou double, au choix", es: "Dos camas o cama doble, a elegir", de: "Zwei Betten oder Doppelbett, nach Wahl" } }
    ]
  },
  {
    "key": "casa-banho",
    "title": { "pt": "Casa de banho", "en": "Bathroom", "fr": "Salle de bain", "es": "Baño", "de": "Badezimmer" },
    "photos": [
      { "src": "/assets/casa/casa-banho/01-img-1232.webp", "alt": { pt: "Detalhes florais", en: "Floral touches", fr: "Touches florales", es: "Detalles florales", de: "Blumige Details" } },
      { "src": "/assets/casa/casa-banho/02-173845.webp", "alt": { pt: "Casa de banho completa", en: "Full bathroom", fr: "Salle de bain complète", es: "Baño completo", de: "Komplettes Badezimmer" } },
      { "src": "/assets/casa/casa-banho/03-173913.webp", "alt": { pt: "Reflexos & luz", en: "Reflections & light", fr: "Reflets & lumière", es: "Reflejos & luz", de: "Reflexionen & Licht" } },
      { "src": "/assets/casa/casa-banho/04-173925.webp", "alt": { pt: "Toalheiro aquecido", en: "Heated towel rail", fr: "Sèche-serviettes chauffant", es: "Toallero calefactado", de: "Beheizter Handtuchhalter" } },
      { "src": "/assets/casa/casa-banho/05-223107.webp", "alt": { pt: "Chuveiro & bidé", en: "Shower & bidet", fr: "Douche & bidet", es: "Ducha & bidé", de: "Dusche & Bidet" } }
    ]
  },
  {
    "key": "terraco",
    "title": { "pt": "Terraço", "en": "Rooftop terrace", "fr": "Terrasse", "es": "Terraza", "de": "Dachterrasse" },
    "photos": [
      { "src": "/assets/casa/terraco/01-172905.webp", "alt": { pt: "Mesa & churrasco", en: "Table & barbecue", fr: "Table & barbecue", es: "Mesa & barbacoa", de: "Tisch & Grill" } },
      { "src": "/assets/casa/terraco/02-221818.webp", "alt": { pt: "Luz de lanterna", en: "Lantern light", fr: "Lumière de la lanterne", es: "Luz de farol", de: "Laternenlicht" } },
      { "src": "/assets/casa/terraco/03-221857.webp", "alt": { pt: "Jantar sob as estrelas", en: "Dinner under the stars", fr: "Dîner sous les étoiles", es: "Cena bajo las estrellas", de: "Abendessen unter Sternen" } },
      { "src": "/assets/casa/terraco/04-222641.webp", "alt": { pt: "Luzes da noite", en: "Night lights", fr: "Lumières de la nuit", es: "Luces de la noche", de: "Nachtlichter" } },
      { "src": "/assets/casa/terraco/05-222729.webp", "alt": { pt: "Descida iluminada", en: "Lit stairway", fr: "Escalier illuminé", es: "Escalera iluminada", de: "Beleuchtete Treppe" } }
    ]
  }
];

const intro = {
  pt: "Todas as fotografias da casa, organizadas por categorias, para conhecer cada detalhe antes da estadia.",
  en: "All house photos, organised by category, so you can see every detail before your stay.",
  fr: "Toutes les photos de la maison, organisées par catégorie, pour découvrir chaque détail avant le séjour.",
  es: "Todas las fotos de la casa, organizadas por categorías, para conocer cada detalle antes de la estancia.",
  de: "Alle Hausfotos, nach Kategorien geordnet, damit Sie jedes Detail vor Ihrem Aufenthalt sehen können.",
};

const photoWord = { pt: "fotos", en: "photos", fr: "photos", es: "fotos", de: "Fotos" };

function ConstructionRibbon({ label }) {
  return (
    <div className="absolute inset-0 pointer-events-none flex items-center justify-center" data-testid="construction-ribbon">
      <span className="font-display uppercase tracking-[0.35em] text-xs sm:text-base md:text-lg select-none text-center px-4" style={{ color: "rgba(255,255,255,0.45)", textShadow: "0 1px 8px rgba(14,26,63,0.45)" }}>
        {label}
      </span>
    </div>
  );
}

function PhotoCard({ category, photo, lang, featured, index, showConstruction, constructionLabel, onOpen }) {
  const label = photo.alt[lang] || photo.alt.pt;
  return (
    <figure
      className={`reveal relative overflow-hidden ${featured ? "rounded-3xl col-span-2 lg:col-span-2 row-span-2 aspect-[4/3] lg:aspect-auto" : "rounded-2xl aspect-[4/5]"} group bg-[#0e1a3f]/10 h-full cursor-zoom-in`}
      data-testid={`galeria-foto-${category.key}-${index + 1}`}
      onClick={() => onOpen(index)}
    >
      <img src={photo.src} alt={label} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
      {showConstruction && <ConstructionRibbon label={constructionLabel} />}
      <figcaption className="absolute bottom-3 left-3 right-3 text-white">
        <span className={`font-display ${featured ? "text-2xl md:text-3xl" : "text-base md:text-lg"} drop-shadow-lg`}>{label}</span>
      </figcaption>
    </figure>
  );
}

function Lightbox({ category, photoIndex, lang, onClose, onPrev, onNext }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose, onPrev, onNext]);

  const photo = category.photos[photoIndex];
  const label = photo.alt[lang] || photo.alt.pt;
  const total = category.photos.length;

  return (
    <div
      className="fixed inset-0 z-[999] bg-[#0e1a3f]/95 backdrop-blur-sm flex flex-col items-center justify-center px-4 py-6"
      data-testid="galeria-lightbox"
      onClick={onClose}
    >
      <button
        type="button"
        aria-label="Fechar"
        className="absolute top-4 right-4 sm:top-6 sm:right-6 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-2.5 transition"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        data-testid="galeria-lightbox-close"
      >
        <X size={22} />
      </button>

      {total > 1 && (
        <button
          type="button"
          aria-label="Anterior"
          className="absolute left-2 sm:left-6 top-1/2 -translate-y-1/2 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-2.5 sm:p-3 transition"
          onClick={(e) => { e.stopPropagation(); onPrev(); }}
          data-testid="galeria-lightbox-prev"
        >
          <ChevronLeft size={26} />
        </button>
      )}

      <img
        src={photo.src}
        alt={label}
        className="max-h-[75vh] max-w-full sm:max-w-[85vw] object-contain rounded-xl shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      />

      <div className="mt-4 text-center text-white" onClick={(e) => e.stopPropagation()}>
        <p className="font-display text-xl sm:text-2xl">{label}</p>
        {total > 1 && <p className="mt-1 text-xs uppercase tracking-[0.2em] text-white/60">{photoIndex + 1} / {total}</p>}
      </div>

      {total > 1 && (
        <button
          type="button"
          aria-label="Seguinte"
          className="absolute right-2 sm:right-6 top-1/2 -translate-y-1/2 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-2.5 sm:p-3 transition"
          onClick={(e) => { e.stopPropagation(); onNext(); }}
          data-testid="galeria-lightbox-next"
        >
          <ChevronRight size={26} />
        </button>
      )}
    </div>
  );
}

export default function Galeria() {
  const { t, lang } = useT();
  const constructionLabel = t.gallery.construction;
  const showConstruction = isPreOpening();
  const [lightbox, setLightbox] = useState(null); // { catKey, photoIndex } | null

  const activeCategory = lightbox ? categories.find((c) => c.key === lightbox.catKey) : null;

  const closeLightbox = () => setLightbox(null);
  const prevPhoto = () => {
    if (!activeCategory) return;
    setLightbox((s) => ({ ...s, photoIndex: (s.photoIndex - 1 + activeCategory.photos.length) % activeCategory.photos.length }));
  };
  const nextPhoto = () => {
    if (!activeCategory) return;
    setLightbox((s) => ({ ...s, photoIndex: (s.photoIndex + 1) % activeCategory.photos.length }));
  };

  return (
    <section id="galeria" className="py-20 md:py-28 bg-[#f3ecdc]" data-testid="galeria-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 reveal">
          <div>
            <p className="section-label">{t.gallery.eyebrow}</p>
            <h2 className="font-display text-4xl md:text-5xl mt-4 text-[#0e1a3f] leading-tight">{t.gallery.title} <em className="text-[#1e3a8a]">{t.gallery.title2}</em></h2>
            <p className="mt-4 text-[#0e1a3f]/70 max-w-2xl leading-relaxed">{intro[lang] || intro.pt}</p>
          </div>
          <a href="#reserva" className="btn-primario self-start md:self-end" data-testid="galeria-cta-reservar">{t.gallery.cta} <ArrowRight size={14} /></a>
        </div>

        <div className="mt-12 space-y-16">
          {categories.map((category) => (
            <div key={category.key} className="reveal">
              <div className="flex items-end justify-between gap-4 mb-5">
                <h3 className="font-display text-3xl md:text-4xl text-[#0e1a3f]">{category.title[lang] || category.title.pt}</h3>
                <span className="text-xs uppercase tracking-[0.22em] text-[#c89033] font-bold">{category.photos.length} {photoWord[lang] || photoWord.pt}</span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 auto-rows-[180px] sm:auto-rows-[220px] lg:auto-rows-[240px]">
                {category.photos.map((photo, i) => (
                  <PhotoCard
                    key={photo.src}
                    category={category}
                    photo={photo}
                    lang={lang}
                    index={i}
                    featured={i === 0}
                    showConstruction={showConstruction}
                    constructionLabel={constructionLabel}
                    onOpen={(idx) => setLightbox({ catKey: category.key, photoIndex: idx })}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        {showConstruction && (
          <p className="text-xs text-[#0e1a3f]/55 mt-5 italic flex items-center gap-2"><HardHat size={14} className="text-[#c89033]" />{t.gallery.note}</p>
        )}
      </div>

      {activeCategory && (
        <Lightbox
          category={activeCategory}
          photoIndex={lightbox.photoIndex}
          lang={lang}
          onClose={closeLightbox}
          onPrev={prevPhoto}
          onNext={nextPhoto}
        />
      )}
    </section>
  );
}
